module.exports = __webpack_public_path__ + "img/WKS_mouth.18ccc8df.jpg";